import { Box, IconButton, Tooltip, Fade } from "@mui/material";
import ShoppingCartOutlinedIcon from "@mui/icons-material/ShoppingCartOutlined";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";

const CartWidget = ({ productsInCart, switchSideCart }) => {
	return (
		<Box className="cartWidget" sx={{ flexGrow: 0 }}>
			<Tooltip
				title="Carrito de compras"
				placement="bottom"
				TransitionComponent={Fade}
				TransitionProps={{ timeout: 600 }}
			>
				<IconButton
					sx={{
						padding: "11px 12px 7px",
					}}
					onClick={switchSideCart}
				>
					{productsInCart > 0 ? (
						<ShoppingCartIcon color="secondary" />
					) : (
						<ShoppingCartOutlinedIcon color="secondary" />
					)}
				</IconButton>
			</Tooltip>
		</Box>
	);
};

export default CartWidget;
